import { ReactNode } from 'react'
import { InfoIcon } from 'lucide-react'
import { Label } from '../../../ui/label'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../../../ui/tooltip'

type Props = {
  label?: string | ReactNode
  tooltip: ReactNode
}

const TooltipLabel = (props: Props) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger type="button">
          {typeof props.label === 'string' ? (
            <Label htmlFor={props.label} className="cursor-pointer gap-2">
              {props.label}
              <InfoIcon size={18} />
            </Label>
          ) : (
            <Label className="cursor-pointer gap-2">
              {props.label}
              <InfoIcon size={18} />
            </Label>
          )}
        </TooltipTrigger>
        <TooltipContent>{props.tooltip}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}

export default TooltipLabel
